import React, { lazy } from 'react';
import { RouteProps } from 'react-router-dom';
import {
	loginPages,
	profilePageMenu,
	masterPageMenu,
	operationsPageMenu,
	userControlAccessPageMenu,
	financePageMenu,
	reportsPageMenu,
	companyPageMenu,
} from '../menu';
import Login from '../pages/presentation/auth/Login';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/dashboard/dashboard-main-page/DashboardPage')),
};
const PROFILE = {
	PROFILE_PAGE: lazy(() => import('../pages/profile/profilePage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};

/*********** COMPANY PAGES COMPONENT START *************************/
const COMPANY = {
	COMPANY_PAGE: lazy(() => import('../pages/company/CompanyPage')),
};
/*********** COMPANY PAGES COMPONENT END *************************/

/*********** USER ACCESS CONTROL PAGES COMPONENT START *************************/
const USERACESSCONTROL = {
	ASSIGNUSERRIGHTS_PAGE: lazy(
		() => import('../pages/user-controls-access/assign-users-rights/AssignUsersRightsPage'),
	),

	MEMBERMANDATORYACCESS_PAGE: lazy(
		() =>
			import(
				'../pages/user-controls-access/member-mandatory-access/member-mandatory-access-page'
			),
	),
	WORKFLOWMANAGEMENT_PAGE: lazy(
		() => import('../pages/user-controls-access/work-flow-management/WorkFlowManagementPage'),
	),

	HIGHMARKRULES_PAGE: lazy(
		() => import('../pages/user-controls-access/high-mark-rules/HighMarkRulesPage'),
	),
	// RULEENGINE_PAGE: lazy(() => import('../pages/user-controls-access/rule-engine/RuleEnginePage')),
};
/*********** USER ACCESS CONTROL PAGES COMPONENT END *************************/

/*********** MASTER PAGES COMPONENT START *************************/
const MASTER = {
	BRANCH_PAGE: lazy(() => import('../pages/master/branch/BranchPage')),
	CENTER_PAGE: lazy(() => import('../pages/master/center/CenterPage')),
	STAFF_PAGE: lazy(() => import('../pages/master/staff/StaffPage')),
	ROLE_PAGE: lazy(() => import('../pages/master/role/RolePage')),
	SAVINGS_PAGE: lazy(() => import('../pages/master/savings/SavingsPage')),
	INSURANCE_COMPANYE_PAGE: lazy(
		() => import('../pages/master/insurance-company/InsuranceCompanyPage'),
	),
	PURPOSEOFLOAN_PAGE: lazy(() => import('../pages/master/purpose-of-loan/purposeOfLoanPage')),
	PURPOSEOFLOANTYPE_PAGE: lazy(
		() => import('../pages/master/purpose-of-loan-type/PurposeOfLoanTypePage'),
	),
	FUNDER_PAGE: lazy(() => import('../pages/master/funder/FunderPage')),
	PRODUCT_TYPE_PAGE: lazy(() => import('../pages/master/product-type/ProductTypePage')),
	// BUSINESS_FUND_PAGE: lazy(() => import('../pages/master/business-fund/business-fund.component')),
	GROUP_PAGE: lazy(() => import('../pages/master/group/GroupPage')),
	ECONOMIC_ACTIVITY_PAGE: lazy(
		() => import('../pages/master/economicActivity/EconomicActivityPage'),
	),
	ECONOMIC_ACTIVITY_TYPE_PAGE: lazy(
		() => import('../pages/master/economic-activity-type/EconomicActivityTypePage'),
	),
	MEMBER_PAGE: lazy(() => import('../pages/master/member/member-list/memberListComponent')),
	PRODUCT_PAGE: lazy(() => import('../pages/master/product/ProductPage')),
	QUESTIONNAIRE_PAGE: lazy(() => import('../pages/master/questionaire/QuestionairePage')),
	BUSINESS_PAGE: lazy(() => import('../pages/master/business/business.component')),
	DEALER_PAGE: lazy(() => import('../pages/master/dealer/DealerPage')),
};
/*********** MASTER PAGES COMPONENT END *************************/

/*********** OPEARTION PAGES COMPONENT START *************************/
const OPEARTION = {
	AUDIT_TOOL_PAGE: lazy(() => import('../pages/operations/auditing-tool/AuditingToolPage')),
	FUNDER_DETAILS: lazy(() => import('../pages/operations/FunderDetails/FunderDetailsPage')),
	CENTER_WISE_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/center-wise-loan-proposal/CenterWiseLoanProposalPage'
			),
	),

	PRODUCT_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/product-loan-proposal/ProductLoanProposalPage'
			),
	),

	CUSTOM_PRODUCT_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/custom-product-loan-proposal/CustomProductLoanProposalPage'
			),
	),
	RANGE_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/range-product-loan-proposal/RangeProductLoanProposalPage'
			),
	),
	INDIVIDUAL_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/individual-loan-proposal/IndividualLoanProposalPage'
			),
	),
	GROUP_WISE_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/group-wise-loan-proposal/GroupWiseLoanProposalPage'
			),
	),
	GOLD_LOAN_PROPOSAL_PAGE: lazy(
		() => import('../pages/operations/loan-proposal/gold-loan-proposal/GoldLoanProposalPage'),
	),
	BUSINESS_LOAN_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/business-loan-proposal/BusinessLoanProposalPage'
			),
	),
	AUTO_LOAN_PROPOSAL_PAGE: lazy(
		() => import('../pages/operations/loan-proposal/auto-loan-proposal/AutoLoanProposalPage'),
	),
	RD_PROPOSAL_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-proposal/recurring-deposit-proposal/RecurringDepositProposalPage'
			),
	),

	//LOAN DISBURSMENT PAGE
	LOAN_INDEX_DISBURSMENT_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-disbursement/loan-index-disbursement/LoanIndexDisbursementPage'
			),
	),
	BUSINESS_LOAN_DISBURSMENT_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-disbursement/business-loan-disbursement/BusinessLoanDisbursementPage'
			),
	),
	GOLD_LOAN_DISBURSMENT_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-disbursement/gold-loan-disbursement/GoldLoanDisbursementPage'
			),
	),
	AUTO_LOAN_DISBURSEMENT_PAGE: lazy(
		() =>
			import(
				'../pages/operations/loan-disbursement/auto-loan-disbursement/AutoLoanDisbursementPage'
			),
	),
	//COLLECTIONS - DEMAND COLLECTION
	DEMAND_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/demandCollection/DemandCollectionPage'),
	),
	ARREAR_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/arrearCollection/ArrearCollectionPage'),
	),

	ADVANCE_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/advanceCollection/AdvanceCollectionPage'),
	),

	GOLD_LOAN_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/goldLoanCollection/GoldLoanCollectionPage'),
	),
	AUTO_LOAN_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/auto-loan-collection/AutoLoanCollectionPage'),
	),

	COLLECTION_APPROVE_PAGE: lazy(
		() => import('../pages/operations/collection-approve/CollectionApprovePage'),
	),

	CLOSE_LOAN_ADVANCE_PAGE: lazy(
		() => import('../pages/operations/close-loan-advance/CloseLoanAdvancePage'),
	),

	CLOSE_LOAN_PAGE: lazy(() => import('../pages/operations/close-loan/CloseLoanPage')),

	GOLD_CLOSE_LOAN_PAGE: lazy(
		() => import('../pages/operations/gold-close-loan/GoldCloseLoanPage'),
	),

	PRE_CLOSE_LOAN_PAGE: lazy(() => import('../pages/operations/pre-close-loan/PreCloseLoanPage')),

	TRANSFER_CENTER_PAGE: lazy(
		() => import('../pages/operations/transfer-center/TransferCenterPage'),
	),

	TRANSFER_FUNDER_PAGE: lazy(
		() => import('../pages/operations/transfer-funder/TransferFunderPage'),
	),

	END_OF_DAY_PAGE: lazy(() => import('../pages/operations/end-of-day/EndOfDayPage')),

	CHANGE_MEETING_DATE_PAGE: lazy(
		() => import('../pages/operations/change-meeting-date/ChangeMeetingDateComponent'),
	),

	CHNAGE_GROUP_OFFICER_PAGE: lazy(
		() => import('../pages/operations/change-group-officer/ChangeGroupOfficerComponent'),
	),

	MEMBER_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/member-collection/MemberCollectionPage'),
	),
	BUSINESS_COLLECTION_PAGE: lazy(
		() => import('../pages/operations/collections/business-collection/BusinessCollectionPage'),
	),
	TRANSFER_BRANCH_PAGE: lazy(
		() => import('../pages/operations/transfer-branch/TransferBranchPage'),
	),
	LAST_EMIDetails: lazy(() => import('../pages/operations/last-emi-details/LastEMIDetailsPage')),
	NACH_UMRN_LINK_PAGE: lazy(() => import('../pages/operations/nach-umrn-link/NachUMRNLinkPage')),
};
/*********** OPEARTION PAGES COMPONENT END *************************/

/*********** REPORT PAGES COMPONENT START *************************/
const REPORTS = {
	REQUEST_REPORT_PAGE: lazy(() => import('../pages/reports/request-report/RequestReportPage')),
	LOAN_DISBURSEMENT_PAGE: lazy(
		() => import('../pages/reports/loan-disbursement-report/LoanDisbursementReportPage'),
	),
	DEMAND_COLLECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/demand-collection-report/DemandCollectionReportPage'),
	),
	GROUP_OFFICER_REPORT_PAGE: lazy(
		() => import('../pages/reports/group-officer-report/GroupOfficerReportPage'),
	),
	FUTURE_DEMAND_REPORT_PAGE: lazy(
		() => import('../pages/reports/future-demand-report/FutureDemandReportPage'),
	),
	MEMBER_DETAILS_REPORT_PAGE: lazy(
		() => import('../pages/reports/member-details-report/MemberDetailsReportComponent'),
	),
	OVERDUE_REPORT_PAGE: lazy(() => import('../pages/reports/over-due-report/OverDueReportPage')),
	PORTFOLIO_REPORT_PAGE: lazy(
		() => import('../pages/reports/portfolio-report/PortfolioReportPage'),
	),
	CENTER_WISE_REPORT_PAGE: lazy(
		() => import('../pages/reports/center-wise-report/CenterWiseReportPage'),
	),
	BRANCH_PROFILE_REPORT_PAGE: lazy(
		() => import('../pages/reports/branch-profile-report/BranchProfileReportPage'),
	),
	LOAN_CARD_REPORT_PAGE: lazy(
		() => import('../pages/reports/loan-card-report/LoanCardReportPage'),
	),
	PORT_FOLIO_AT_RISK_REPORT_PAGE: lazy(
		() => import('../pages/reports/portfolio-at-risk-report/PortfolioAtRiskReportPage'),
	),
	ARREAR_FOLLOWUP_REPORT_PAGE: lazy(
		() => import('../pages/reports/arrear-followup-report/ArrearFollowupReportPage'),
	),
	DAILY_COLLECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/daily-collection-report/DailyCollectionReportPage'),
	),
	BRANCH_DCB_REPORT_PAGE: lazy(
		() => import('../pages/reports/branch-DCB-report/BranchDCBReportPage'),
	),
	CENTER_DCB_REPORT_PAGE: lazy(
		() => import('../pages/reports/center-DCB-report/CenterDCBReportPage'),
	),
	DEMAND_FOLLOWUP_REPORT_PAGE: lazy(
		() => import('../pages/reports/demand-followup-report/DemandFollowupReportPage'),
	),
	DAY_BOOK_REPORT_PAGE: lazy(() => import('../pages/reports/day-book-report/DayBookReportPage')),
	BRANCH_COLLECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/branch-collection-report/BranchCollectionReportPage'),
	),
	WALLET_REPORT_PAGE: lazy(() => import('../pages/reports/wallet-report/WalletReportPage')),
	THRIFT_REPORT_PAGE: lazy(() => import('../pages/reports/thrift-report/ThriftReportPage')),
	CLOSED_LOAN_REPORT_PAGE: lazy(
		() => import('../pages/reports/closed-loan-report/ClosedLoanReportPage'),
	),
	DEAD_MEMBER_DETAILS_PAGE: lazy(
		() => import('../pages/reports/dead-member-report/DeadMemberReportPage'),
	),
	PRECLOSED_LOAN_REPORT_PAGE: lazy(
		() => import('../pages/reports/preclose-loan-report/PrecloseLoanReportPage'),
	),
	CHANGE_MEETING_REPORT_PAGE: lazy(
		() => import('../pages/reports/change-meeting-report/ChangeMeetingReportPage'),
	),
	GROUP_REPORT_PAGE: lazy(() => import('../pages/reports/group-report/GroupReportPage')),
	ACTIVE_MEMBER_REPORT_PAGE: lazy(
		() => import('../pages/reports/active-member-report/ActiveMemberReportPage'),
	),
	INSURANCE_REPORT_PAGE: lazy(
		() => import('../pages/reports/insurance-report/InsuranceReportPage'),
	),
	INACTIVE_MEMBER_REPORT_PAGE: lazy(
		() => import('../pages/reports/inactive-member-report/InactiveMemberPage'),
	),
	ENACH_REPORT_PAGE: lazy(() => import('../pages/reports/enach-report/enach-report-page')),
	MANDATE_REPORT_PAGE: lazy(
		() => import('../pages/reports/mandate-report-details/MandateReportPage'),
	),
	QR_REPORT_PAGE: lazy(() => import('../pages/reports/qr-report/QrReportPage')),
	MEMBER_REJECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/member-rejection-report/MemberRejectionReportPage'),
	),
	ATTENDANCE_REPORT_PAGE: lazy(
		() => import('../pages/reports/attendance-report/AttendanceReportPage'),
	),
	SANCTION_REPORT_PAGE: lazy(() => import('../pages/reports/sanction-report/SanctionReportPage')),
	STAFF_DETAIL_REPORT_PAGE: lazy(
		() => import('../pages/reports/staff-detail-report/StaffReportPage'),
	),
	MONTHLY_PROGRESS_REPORT_PAGE: lazy(
		() => import('../pages/reports/monthly-progress-report/MonthlyProgressReportPage'),
	),
	AUDITING_TOOL_REPORT_PAGE: lazy(
		() => import('../pages/reports/auditing-tool-report/AuditingToolReportPage'),
	),
	KYC_SOURCED_REPORT_PAGE: lazy(
		() => import('../pages/reports/kyc-sourced-report/KYCSourcedReportPage'),
	),
	MEMBER_ACCOUNT_REPORT_PAGE: lazy(
		() => import('../pages/reports/member-account-report/MemberAccountReportPage'),
	),
	SAVINGS_FOLLOWUP_REPORT_PAGE: lazy(
		() => import('../pages/reports/savings-followup-report/SavingsFollowupPage'),
	),
	// POST_AUDITING_TOOL_REPORT_PAGE: lazy(
	// 	() => import('../pages/reports/post-auditing-tool-report/PostAuditingToolReportPage'),
	// ),
	LEAD_REPORT_PAGE: lazy(() => import('../pages/reports/lead-report/LeadReportPage')),
	GOLD_PRICE_REPORT_PAGE: lazy(
		() => import('../pages/reports/gold-price-report/GoldPriceReport'),
	),
	GOLD_LOAN_ARREAR_PAGE: lazy(
		() => import('../pages/reports/gold-loan-arrear-report/GoldLoanArrearReport'),
	),
	GOLD_LOAN_COLLECTION_PAGE: lazy(
		() => import('../pages/reports/gold-loan-collection/GoldLoanCollectionReportPage'),
	),
	GOLD_LOAN_STACK_REPORT_PAGE: lazy(
		() => import('../pages/reports/gold-stock-report/GoldStockReportPage'),
	),
	GOLD_LOAN_INTEREST_REMINDER_PAGE: lazy(
		() =>
			import(
				'../pages/reports/gold-loan-interest-reminder-report/GoldLoanInterestReminderPage'
			),
	),
	MEMBER_ATTENDANCE_REPORT_PAGE: lazy(
		() => import('../pages/reports/member-attendance-report/MemberAttendanceReportPage'),
	),
	NPA_REPORT_PAGE: lazy(() => import('../pages/reports/npa-report/NpaReportPage')),
	EOD_REPORT_PAGE: lazy(() => import('../pages/reports/eod-report/EODReportPage')),
	REPAYMENT_COLLECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/repayment-collection-report/RepaymentCollectionReport'),
	),
	PROGRESS_REPORT_PAGE: lazy(() => import('../pages/reports/progress-report/ProgressReportPage')),
	PROMISE_TO_PAY_REPORT_PAGE: lazy(
		() => import('../pages/reports/promise-to-pay-report/PromiseToPayReportPage'),
	),
	MONTH_WISE_INTEREST_SUMMARY_REPORT_PAGE: lazy(
		() =>
			import(
				'../pages/reports/month-wise-interest-summary-report/MonthWiseInterestSummaryReportPage'
			),
	),
	BALANCESHEET_PAGE: lazy(
		() => import('../pages/finance/reports/balance-sheet/BalanceSheetPage'),
	),
	OFFICER_LOCATION_REPORT_PAGE: lazy(
		() => import('../pages/reports/officer-location/OfficerLocationReportPage'),
	),
	AUTO_COLLECTION_REPORT_PAGE: lazy(
		() => import('../pages/reports/auto-loan-report/AutoCollectionPageReport'),
	),
	CREDIT_BUREAU_REPORT_PAGE: lazy(
		() => import('../pages/reports/credit-bureau-report/CreditBureauReportPage'),
	),
	DATA_VERIFICATION_REPORT_PAGE: lazy(
		() => import('../pages/reports/data-verification-report/DataVerificationReportPage'),
	),
	ACCURED_INTEREST_REPORT_PAGE: lazy(
		() => import('../pages/reports/accured-interest-report/AccuredInterestReport'),
	),
	// COLLECTION_FORMAT_REPORT_PAGE: lazy(
	// 	() => import('../pages/reports/collection-format-report/CollectionFormatReportPage'),
	// ),
	// BRANCH_SUMMARY_REPORT_PAGE: lazy(
	// 	() => import('../pages/reports/branch-summary-report/BranchSummaryReportPage'),
	// ),
	VEHICLE_SEIZED_REPORT_PAGE: lazy(
		() => import('../pages/reports/vehicle-seized-report/VehicleSeizedReportPage'),
	),
	DEALER_REPORT_PAGE: lazy(() => import('../pages/reports/dealer-report/DealerReportPage')),
};
/*********** REPORT PAGES COMPONENT END *************************/

/*********** FINANCE PAGES COMPONENT START *************************/
const FINANCE = {
	// FINANCE - MASTER - GROUP ACCOUNT
	GST_TYPE_PAGE: lazy(() => import('../pages/finance/master/gstType/GstTypePage')),
	INSTRUMENT_PAGE: lazy(() => import('../pages/finance/master/instrument/InstrumentPage')),
	ACCOUNT_PAGE: lazy(() => import('../pages/finance/master/accounts/AccountsPage')),
	OPENING_BALANCE_PAGE: lazy(
		() => import('../pages/finance/master/opening-balance/OpeningBalancePage'),
	),
	ACCOUNT_MAPPING_PAGE: lazy(
		() => import('../pages/finance/master/account-mapping/AccountMappingPage'),
	),
	GROUP_ACCOUNT: lazy(() => import('../pages/finance/master/groupAccount/GroupAccountPage')),

	TRAIL_BALANCE_REPORT_PAGE: lazy(
		() => import('../pages/finance/reports/TrailBalance/TrailBalancePage'),
	),
	SUB_GROUP_ACCOUNT_PAGE: lazy(
		() => import('../pages/finance/master/subGroupAccount/SubGroupAccountPage'),
	),

	// FNANCE - REPORTS
	LEDGER_REPORTS_PAGE: lazy(
		() => import('../pages/finance/reports/ledgerReports/LedgerReportsPage'),
	),

	PROFIT_AND_LOSS_REPORT_PAGE: lazy(
		() => import('../pages/reports/profit-and-loss/ProfitAndLossReportPage'),
	),
	RECEIPTS_AND_PAYMENTS_PAGE: lazy(
		() => import('../pages/finance/reports/ReceiptsAndPayments/ReceiptsAndPaymentsPage'),
	),
	// BANKTRANSACTION_PAGE: lazy(
	// 	() => import('../pages/finance/master/transaction/bankTranction/BankTranscationPage'),
	// ),
	DAYBOOKREPORT_PAGE: lazy(() => import('../pages/finance/reports/dayBookReport/dayBookPage')),
};
/*********** FINANCE PAGES COMPONENT END *************************/

// TRANSACTION - CASH TRANSACTION
const CASH_TRANSACTION = {
	CASH_TRANSACTION_PAGE: lazy(
		() => import('../pages/finance/transaction/cashTransaction/CashTransactionPage'),
	),
};

// JOURNAL TRANSACTION
const JOURNAL_TRANSACTION = {
	JOURNAL_TRANSACTION_PAGE: lazy(
		() => import('../pages/finance/transaction/journalTransaction/JournalTransactionPage'),
	),
};

// BANK TRANSACTION
const BANK_TRANSACTION = {
	BANK_TRANSACTION_PAGE: lazy(
		() => import('../pages/finance/transaction/bankTranction/BankTranscationPage'),
	),
};

const presentation: RouteProps[] = [
	/**
	 * Landing
	 */
	{
		path: loginPages.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	/** ************************************************** */

	/** ********************* LOGIN START ***************************** */
	{
		path: loginPages.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: loginPages.login.path,
		element: <Login />,
	},
	// {
	// 	path: loginPages.signUp.path,
	// 	element: <Login isSignUp />,
	// },
	/** ********************* LOGIN END ***************************** */

	/**
	 * App > CRM
	 */
	// {
	// 	path: demoPagesMenu.crm.subMenu.customersList.path,
	// 	element: <APP.CRM.CUSTOMERS />,
	// },
	/**
	 * END - App
	 */

	/** ************************************************** */

	/** ********************* LOGIN START ***************************** */
	{
		path: profilePageMenu.profile.path,
		element: <PROFILE.PROFILE_PAGE />,
	},

	/** ********************* LOGIN END ***************************** */
	/** ********************* USER CONTROL ACCESS START ***************************** */

	{
		path: userControlAccessPageMenu.userControlAccessPages.subMenu.assignUserRights.path,
		element: <USERACESSCONTROL.ASSIGNUSERRIGHTS_PAGE />,
	},

	{
		path: userControlAccessPageMenu.userControlAccessPages.subMenu.memberMandatoryAccess.path,
		element: <USERACESSCONTROL.MEMBERMANDATORYACCESS_PAGE />,
	},
	{
		path: userControlAccessPageMenu.userControlAccessPages.subMenu.workFlowManagement.path,
		element: <USERACESSCONTROL.WORKFLOWMANAGEMENT_PAGE />,
	},
	{
		path: userControlAccessPageMenu.userControlAccessPages.subMenu.highmarkRules.path,
		element: <USERACESSCONTROL.HIGHMARKRULES_PAGE />,
	},
	// {
	// 	path: userControlAccessPageMenu.userControlAccessPages.subMenu.ruleEngine.path,
	// 	element: <USERACESSCONTROL.RULEENGINE_PAGE />,
	// },
	/** ********************* USER CONTROL ACCESS END ***************************** */

	/** ********************* COMPANY PAGE START ***************************** */
	{
		path: companyPageMenu.companyPages.subMenu.companyPage.path,
		element: <COMPANY.COMPANY_PAGE />,
	},
	/** ********************* COMPANY PAGE END ***************************** */

	/** ********************* MASTER START ***************************** */
	{
		path: masterPageMenu.masterPages.subMenu.branchPage.path,
		element: <MASTER.BRANCH_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.centerPage.path,
		element: <MASTER.CENTER_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.staffPage.path,
		element: <MASTER.STAFF_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.rolePage.path,
		element: <MASTER.ROLE_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.savingsPage.path,
		element: <MASTER.SAVINGS_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.memberPage.path,
		element: <MASTER.MEMBER_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.insurance_company.path,
		element: <MASTER.INSURANCE_COMPANYE_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.purposeOfLoanPage.path,
		element: <MASTER.PURPOSEOFLOAN_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.purposeOfLoanTypePage.path,
		element: <MASTER.PURPOSEOFLOANTYPE_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.funderPage.path,
		element: <MASTER.FUNDER_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.fetchProductType.path,
		element: <MASTER.PRODUCT_TYPE_PAGE />,
	},
	// {
	// 	path: masterPageMenu.masterPages.subMenu.business_fund.path,
	// 	element: <MASTER.BUSINESS_FUND_PAGE />,
	// },
	{
		path: masterPageMenu.masterPages.subMenu.group.path,
		element: <MASTER.GROUP_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.economicActivity.path,
		element: <MASTER.ECONOMIC_ACTIVITY_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.economicActivityType.path,
		element: <MASTER.ECONOMIC_ACTIVITY_TYPE_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.product.path,
		element: <MASTER.PRODUCT_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.questionnaire.path,
		element: <MASTER.QUESTIONNAIRE_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.business.path,
		element: <MASTER.BUSINESS_PAGE />,
	},
	{
		path: masterPageMenu.masterPages.subMenu.dealer.path,
		element: <MASTER.DEALER_PAGE />,
	},

	/** ********************* MASTER END ***************************** */

	/** ********************* OPERATIONS START ***************************** */
	{
		path: operationsPageMenu.operationPages.subMenu.funderDetails.path,
		element: <OPEARTION.FUNDER_DETAILS />,
	},

	{
		path: operationsPageMenu.operationPages.subMenu.auditTool.path,
		element: <OPEARTION.AUDIT_TOOL_PAGE />,
	},

	{
		path: operationsPageMenu.operationPages.subMenu.transferCenterPage.path,
		element: <OPEARTION.TRANSFER_CENTER_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.transferBranchPage.path,
		element: <OPEARTION.TRANSFER_BRANCH_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.transferFunderPage.path,
		element: <OPEARTION.TRANSFER_FUNDER_PAGE />,
	},
	// OPERATIONS - LOAN PROPOSAL
	{
		path: operationsPageMenu.operationPages.subMenu.CenterWiseLoanProposal.path,
		element: <OPEARTION.CENTER_WISE_LOAN_PROPOSAL_PAGE />,
	},
	// {
	// 	path: operationsPageMenu.operationPages.subMenu.ProductLoanProposal.path,
	// 	element: <OPEARTION.PRODUCT_LOAN_PROPOSAL_PAGE />,
	// },
	// {
	// 	path: operationsPageMenu.operationPages.subMenu.CustomProductLoanProposal.path,
	// 	element: <OPEARTION.CUSTOM_PRODUCT_LOAN_PROPOSAL_PAGE />,
	// },
	{
		path: operationsPageMenu.operationPages.subMenu.RangeLoanProposal.path,
		element: <OPEARTION.RANGE_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.GroupWiseLoanProposal.path,
		element: <OPEARTION.GROUP_WISE_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.IndividualLoanProposal.path,
		element: <OPEARTION.INDIVIDUAL_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.GoldLoanProposal.path,
		element: <OPEARTION.GOLD_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.BusinessLoanProposal.path,
		element: <OPEARTION.BUSINESS_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.autoLoanProposalPage.path,
		element: <OPEARTION.AUTO_LOAN_PROPOSAL_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.RDProposal.path,
		element: <OPEARTION.RD_PROPOSAL_PAGE />,
	},
	// COLLECTION - DEMAND COLLECTION
	{
		path: operationsPageMenu.operationPages.subMenu.demandCollectionPage.path,
		element: <OPEARTION.DEMAND_COLLECTION_PAGE />,
	},

	{
		path: operationsPageMenu.operationPages.subMenu.advanceCollectionPage.path,
		element: <OPEARTION.ADVANCE_COLLECTION_PAGE />,
	},

	{
		path: operationsPageMenu.operationPages.subMenu.goldCollectionPage.path,
		element: <OPEARTION.GOLD_LOAN_COLLECTION_PAGE />,
	},

	{
		path: operationsPageMenu.operationPages.subMenu.arrearCollectionPage.path,
		element: <OPEARTION.ARREAR_COLLECTION_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.autoLoanCollectionPage.path,
		element: <OPEARTION.AUTO_LOAN_COLLECTION_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.closeLoanAdvancePage.path,
		element: <OPEARTION.CLOSE_LOAN_ADVANCE_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.collectionApprovePage.path,
		element: <OPEARTION.COLLECTION_APPROVE_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.closeLoanPage.path,
		element: <OPEARTION.CLOSE_LOAN_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.goldCloseLoanPage.path,
		element: <OPEARTION.GOLD_CLOSE_LOAN_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.preCloseLoanPage.path,
		element: <OPEARTION.PRE_CLOSE_LOAN_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.endOfDayPage.path,
		element: <OPEARTION.END_OF_DAY_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.changeMeetingDate.path,
		element: <OPEARTION.CHANGE_MEETING_DATE_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.changeGroupOfficer.path,
		element: <OPEARTION.CHNAGE_GROUP_OFFICER_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.memberCollectionPage.path,
		element: <OPEARTION.MEMBER_COLLECTION_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.businessCollectionPage.path,
		element: <OPEARTION.BUSINESS_COLLECTION_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.lastEMIDetails.path,
		element: <OPEARTION.LAST_EMIDetails />,
	},

	// LOAN DISBURSMENT
	{
		path: operationsPageMenu.operationPages.subMenu.loanIndexDisbursementPage.path,
		element: <OPEARTION.LOAN_INDEX_DISBURSMENT_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.businessLoanDisbursementPage.path,
		element: <OPEARTION.BUSINESS_LOAN_DISBURSMENT_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.goldLoanDisbursementPage.path,
		element: <OPEARTION.GOLD_LOAN_DISBURSMENT_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.autoLoanDisbursemetPage.path,
		element: <OPEARTION.AUTO_LOAN_DISBURSEMENT_PAGE />,
	},
	{
		path: operationsPageMenu.operationPages.subMenu.nachUMRNlink.path,
		element: <OPEARTION.NACH_UMRN_LINK_PAGE />,
	},

	/** ********************* OPERATIONS END ***************************** */

	/** ********************* REPORT START ***************************** */
	{
		path: reportsPageMenu.reportsPages.subMenu.requestReport.path,
		element: <REPORTS.REQUEST_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.groupOfficerReport.path,
		element: <REPORTS.GROUP_OFFICER_REPORT_PAGE />,
	},

	{
		path: reportsPageMenu.reportsPages.subMenu.loanDisbursement.path,
		element: <REPORTS.LOAN_DISBURSEMENT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.demandCollectionReport.path,
		element: <REPORTS.DEMAND_COLLECTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.futureDemandReport.path,
		element: <REPORTS.FUTURE_DEMAND_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.MemberDetailsReport.path,
		element: <REPORTS.MEMBER_DETAILS_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.OverDueReport.path,
		element: <REPORTS.OVERDUE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.portfolioReport.path,
		element: <REPORTS.PORTFOLIO_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.centerWiseReport.path,
		element: <REPORTS.CENTER_WISE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.branchProfileReport.path,
		element: <REPORTS.BRANCH_PROFILE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.loanCardReport.path,
		element: <REPORTS.LOAN_CARD_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.PortFolioAtRiskReport.path,
		element: <REPORTS.PORT_FOLIO_AT_RISK_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.ArrearFollowupReport.path,
		element: <REPORTS.ARREAR_FOLLOWUP_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DailyCollectionReport.path,
		element: <REPORTS.DAILY_COLLECTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.branchDCBReport.path,
		element: <REPORTS.BRANCH_DCB_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.centerDCBReport.path,
		element: <REPORTS.CENTER_DCB_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DemandFollowupReport.path,
		element: <REPORTS.DEMAND_FOLLOWUP_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DayBookReport.path,
		element: <REPORTS.DAY_BOOK_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.walletReport.path,
		element: <REPORTS.WALLET_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.thriftReport.path,
		element: <REPORTS.THRIFT_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.branchCollectionReport.path,
		element: <REPORTS.BRANCH_COLLECTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.closedLoanReport.path,
		element: <REPORTS.CLOSED_LOAN_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DeadMemberDetails.path,
		element: <REPORTS.DEAD_MEMBER_DETAILS_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.preclosedLoanReport.path,
		element: <REPORTS.PRECLOSED_LOAN_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.ChangeMeetingReport.path,
		element: <REPORTS.CHANGE_MEETING_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.groupReport.path,
		element: <REPORTS.GROUP_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.activeMemberReport.path,
		element: <REPORTS.ACTIVE_MEMBER_REPORT_PAGE />,
	},

	{
		path: reportsPageMenu.reportsPages.subMenu.qrReport.path,
		element: <REPORTS.QR_REPORT_PAGE />,
	},
	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.AuditTrailReport.path,
	// 	element: <AUDIT_TRAIL_REPORT.AUDIT_TRAIL_REPORT_PAGE />,
	// },
	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.memberRejectionReport.path,
	// 	element: <REPORTS.MEMBER_REJECTION_REPORT_PAGE />,
	// },
	{
		path: reportsPageMenu.reportsPages.subMenu.attendanceReport.path,
		element: <REPORTS.ATTENDANCE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.sanctionReport.path,
		element: <REPORTS.SANCTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.staffDetailReport.path,
		element: <REPORTS.STAFF_DETAIL_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.monthlyprogressReport.path,
		element: <REPORTS.MONTHLY_PROGRESS_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.auditingToolReport.path,
		element: <REPORTS.AUDITING_TOOL_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.kycSourcedReport.path,
		element: <REPORTS.KYC_SOURCED_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.memberAccountReport.path,
		element: <REPORTS.MEMBER_ACCOUNT_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.savingsFollowupReport.path,
		element: <REPORTS.SAVINGS_FOLLOWUP_REPORT_PAGE />,
	},
	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.postAuditingToolReport.path,
	// 	element: <REPORTS.POST_AUDITING_TOOL_REPORT_PAGE />,
	// },
	{
		path: reportsPageMenu.reportsPages.subMenu.memberAttendanceReport.path,
		element: <REPORTS.MEMBER_ATTENDANCE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.NpaReport.path,
		element: <REPORTS.NPA_REPORT_PAGE />,
	},

	{
		path: reportsPageMenu.reportsPages.subMenu.insuranceReport.path,
		element: <REPORTS.INSURANCE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.inActiveMemberReport.path,
		element: <REPORTS.INACTIVE_MEMBER_REPORT_PAGE />,
	},

	{
		path: reportsPageMenu.reportsPages.subMenu.enachReport.path,
		element: <REPORTS.ENACH_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.mandateReport.path,
		element: <REPORTS.MANDATE_REPORT_PAGE />,
	},
	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.leadReport.path,
	// 	element: <REPORTS.LEAD_REPORT_PAGE />,
	// },c
	{
		path: reportsPageMenu.reportsPages.subMenu.goldPriceReport.path,
		element: <REPORTS.GOLD_PRICE_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.goldArrearReport.path,
		element: <REPORTS.GOLD_LOAN_ARREAR_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.goldLoanCollectionReport.path,
		element: <REPORTS.GOLD_LOAN_COLLECTION_PAGE />,
	},

	{
		path: reportsPageMenu.reportsPages.subMenu.goldLoanStockReport.path,
		element: <REPORTS.GOLD_LOAN_STACK_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.goldLoanInterestReminderReport.path,
		element: <REPORTS.GOLD_LOAN_INTEREST_REMINDER_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.progressReport.path,
		element: <REPORTS.PROGRESS_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.eodReport.path,
		element: <REPORTS.EOD_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.repaymentCollectionReport.path,
		element: <REPORTS.REPAYMENT_COLLECTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.promiseToPayReport.path,
		element: <REPORTS.PROMISE_TO_PAY_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.monthWiseInterestSummaryReport.path,
		element: <REPORTS.MONTH_WISE_INTEREST_SUMMARY_REPORT_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.BalanceSheet.path,
		element: <REPORTS.BALANCESHEET_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.DayBookReport.path,
		element: <FINANCE.DAYBOOKREPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.officerLocationReport.path,
		element: <REPORTS.OFFICER_LOCATION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.AutoCollectionPageReport.path,
		element: <REPORTS.AUTO_COLLECTION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.CreditBureauReport.path,
		element: <REPORTS.CREDIT_BUREAU_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DataVerificationReport.path,
		element: <REPORTS.DATA_VERIFICATION_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.AccuredInterestReport.path,
		element: <REPORTS.ACCURED_INTEREST_REPORT_PAGE />,
	},

	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.CollectionFormatReport.path,
	// 	element: <REPORTS.COLLECTION_FORMAT_REPORT_PAGE />,
	// },
	// {
	// 	path: reportsPageMenu.reportsPages.subMenu.BranchSummaryReport.path,
	// 	element: <REPORTS.BRANCH_SUMMARY_REPORT_PAGE />,
	// },
	{
		path: reportsPageMenu.reportsPages.subMenu.VehicleSeizedReport.path,
		element: <REPORTS.VEHICLE_SEIZED_REPORT_PAGE />,
	},
	{
		path: reportsPageMenu.reportsPages.subMenu.DealerReport.path,
		element: <REPORTS.DEALER_REPORT_PAGE />,
	},

	/** ********************* REPORT END ***************************** */

	/** ********************* FINANCE START ***************************** */
	{
		path: financePageMenu.financePages.subMenu.GstType.path,
		element: <FINANCE.GST_TYPE_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.Instrument.path,
		element: <FINANCE.INSTRUMENT_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.OpeningBalance.path,
		element: <FINANCE.OPENING_BALANCE_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.GroupAccount.path,
		element: <FINANCE.GROUP_ACCOUNT />,
	},
	{
		path: financePageMenu.financePages.subMenu.AccountMapping.path,
		element: <FINANCE.ACCOUNT_MAPPING_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.SubGroupAccount.path,
		element: <FINANCE.SUB_GROUP_ACCOUNT_PAGE />,
	},
	/** ******************    TRANSACTION  START    *************************** */
	{
		path: financePageMenu.financePages.subMenu.CashTransaction.path,
		element: <CASH_TRANSACTION.CASH_TRANSACTION_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.BankTransaction.path,
		element: <BANK_TRANSACTION.BANK_TRANSACTION_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.JournalTransaction.path,
		element: <JOURNAL_TRANSACTION.JOURNAL_TRANSACTION_PAGE />,
	},
	/** ********************* FINANCE END ***************************** */
	{
		path: financePageMenu.financePages.subMenu.LedgerReports.path,
		element: <FINANCE.LEDGER_REPORTS_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.profitAndLossReport.path,
		element: <FINANCE.PROFIT_AND_LOSS_REPORT_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.TrailBalance.path,
		element: <FINANCE.TRAIL_BALANCE_REPORT_PAGE />,
	},
	{
		path: financePageMenu.financePages.subMenu.ReceiptsPayments.path,
		element: <FINANCE.RECEIPTS_AND_PAYMENTS_PAGE />,
	},
	/** ********************* FINANCE END ***************************** */
	{
		path: financePageMenu.financePages.subMenu.Accounts.path,
		element: <FINANCE.ACCOUNT_PAGE />,
	},
];

const contents = [...presentation];

export default contents;
